import { render, staticRenderFns } from "./SampleRequestViewer.vue?vue&type=template&id=bc6b4402&scoped=true"
import script from "./SampleRequestViewer.vue?vue&type=script&lang=js"
export * from "./SampleRequestViewer.vue?vue&type=script&lang=js"
import style0 from "./SampleRequestViewer.vue?vue&type=style&index=0&id=bc6b4402&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6b4402",
  null
  
)

export default component.exports